import get from 'lodash.get';
import { NotificationService } from 'ui-components/services/notification-service';
import { of, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { emptyObject } from 'ui-components/default-props/empty';
import * as Actions from '../../store/bulk/bulk.actions';

import { orderGridReloadSubject } from '../orders/grid/orders.grid.observables';

export const createLabelProcessing = (action$) => {
  return action$.pipe(
    ofType(Actions.BULK_END_PROCESSING_CREATE_LABEL),
    mergeMap((action) => {
      const { errored } = action;
      const metadata = get(action, 'metadata', emptyObject);
      const actionCreator = get(metadata, 'actionCreator');
      const notificationId = get(metadata, 'notificationId');

      if (notificationId) {
        NotificationService.removeNotification(notificationId);
      }

      if (!metadata.fromSingleLabel) {
        return EMPTY;
      }

      if (!actionCreator) {
        return EMPTY;
      }

      if (errored === undefined || errored.length === 0) {
        return of(actionCreator(metadata));
      }

      return EMPTY;
    }),
  );
};

export const refreshOrdersGridAfterCreateLabel = (action$) => {
  return action$.pipe(
    ofType(Actions.BULK_END_PROCESSING_CREATE_LABEL),
    mergeMap(() => {
      orderGridReloadSubject.next();
      return EMPTY;
    }),
  );
};
